export interface Movie {
  id: string;
  title: string;
  titleEn: string;
  year: number;
  category: string;
  rating: number;
  description: string;
  longDescription: string;
  director: string;
  cast: string[];
  duration: string;
  region: string;
  releaseDate: string;
  updateDate: string;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
}

export const categories = [
  { key: 'all', label: '全部', icon: 'ri-movie-line' },
  { key: 'movie', label: '电影', icon: 'ri-film-line' },
  { key: 'tv', label: '电视剧', icon: 'ri-tv-line' },
  { key: 'variety', label: '综艺', icon: 'ri-live-line' },
  { key: 'anime', label: '动漫', icon: 'ri-emotion-line' },
  { key: 'doc', label: '纪录片', icon: 'ri-slideshow-line' },
];

export const movies: Movie[] = [
  {
    id: 'm1',
    title: '流浪地球3',
    titleEn: 'The Wandering Earth 3',
    year: 2026,
    category: 'movie',
    rating: 8.6,
    description: '太阳急速衰老膨胀，人类在地球表面建造出巨大的推进器，寻找新的家园。面对前所未有的危机，人类再次团结一致，踏上远征之路。',
    longDescription: '在不远的未来，太阳急速衰老膨胀，地球面临被吞没的灭顶之灾。为拯救地球，人类在地球表面建造了上万座行星发动机，以逃离太阳系寻找新的家园。在这场跨越2500年的漫长旅程中，人类将面对宇宙未知的挑战，也将在绝望中寻找希望的火种。流浪地球计划第三阶段正式启动，人类命运再次悬于一线。',
    director: '郭帆',
    cast: ['吴京', '刘德华', '李雪健', '沙溢', '宁理'],
    duration: '148分钟',
    region: '中国大陆',
    releaseDate: '2026-01-29',
    updateDate: '2026-07-30',
    tags: ['科幻', '灾难', '冒险', '国产大片'],
    isHot: true,
    isNew: false,
  },
  {
    id: 'm2',
    title: '哪吒之魔童闹海',
    titleEn: 'Ne Zha 2',
    year: 2025,
    category: 'movie',
    rating: 8.9,
    description: '天劫之后，哪吒和敖丙的灵魂虽保住了，但肉身却面临魂飞魄散。太乙真人打算用七色宝莲为二人重塑肉身，过程却充满变数。',
    longDescription: '天劫之后，哪吒、敖丙的灵魂虽保住了，但肉身很快会魂飞魄散。太乙真人打算用七色宝莲给二人重塑肉身，但在重塑肉身的过程中却遇到重重困难。哪吒不仅要面对来自天庭的压力，还要揭开自己身世的更多秘密。这部续作延续了前作的幽默风格，同时加入了更多感人至深的情感元素和震撼的视觉效果。',
    director: '饺子',
    cast: ['吕艳婷', '囧森瑟夫', '瀚墨', '陈浩'],
    duration: '144分钟',
    region: '中国大陆',
    releaseDate: '2025-01-29',
    updateDate: '2026-07-28',
    tags: ['动画', '奇幻', '喜剧', '国产动画'],
    isHot: true,
    isNew: false,
  },
  {
    id: 'm3',
    title: '热辣滚烫',
    titleEn: 'YOLO',
    year: 2024,
    category: 'movie',
    rating: 7.8,
    description: '乐莹是一个善良的人，但生活却给了她一记又一记重拳。当她遇到拳击教练昊坤后，人生开始发生改变。',
    longDescription: '乐莹是一个善良温柔的女孩，但生活却总是给予她一次又一次的重击。在经历了一系列的人生低谷后，她偶然遇到了拳击教练昊坤。两人因拳击结缘，乐莹也在这项运动中重新找到了自己。这是一个关于成长、蜕变和找到自我的温情故事，证明了任何时候开始都不算晚。',
    director: '贾玲',
    cast: ['贾玲', '雷佳音', '张小斐', '杨紫'],
    duration: '129分钟',
    region: '中国大陆',
    releaseDate: '2024-02-10',
    updateDate: '2026-07-15',
    tags: ['喜剧', '剧情', '励志', '女性'],
    isHot: true,
    isNew: false,
  },
  {
    id: 'm4',
    title: '封神第二部：战火西岐',
    titleEn: 'Creation of the Gods II',
    year: 2025,
    category: 'movie',
    rating: 8.2,
    description: '商王殷寿的暴虐统治下，姬发回到西岐，带领西岐军民奋起反抗。一场决定天下命运的战争即将在西岐展开。',
    longDescription: '大商二王子殷寿带领的军队攻破冀州，苏妲己的美貌让殷寿魂牵梦萦。而回到西岐的姬发，发现了纣王的暴虐无道。他集结西岐军民，准备对抗商朝大军。在这一部中，我们将看到西岐与商朝之间的史诗级战争，神仙斗法、宏大场面，一场神话史诗的视觉盛宴就此展开。',
    director: '乌尔善',
    cast: ['黄渤', '于适', '那尔那茜', '陈坤', '费翔'],
    duration: '150分钟',
    region: '中国大陆',
    releaseDate: '2025-07-26',
    updateDate: '2026-07-25',
    tags: ['奇幻', '动作', '神话', '史诗'],
    isHot: false,
    isNew: true,
  },
  {
    id: 'm5',
    title: '第二十条',
    titleEn: 'Article 20',
    year: 2024,
    category: 'movie',
    rating: 7.9,
    description: '人到中年的检察官韩明接手了一起案情十分复杂的案件。在法与情之间，他必须做出最艰难的决定。',
    longDescription: '检察官韩明已到中年，本想努力赶上职业生涯末班车进入市院工作。不料却卷入了一宗分歧巨大的案件，而与此同时他的家里也面临着相似的考验。这部现实主义题材影片通过一系列案件，深入探讨了正当防卫的法律界定，以及法律与人情之间的微妙平衡。张艺谋导演以他一贯的细腻手法，展现了普通人面对法律时的真实处境。',
    director: '张艺谋',
    cast: ['雷佳音', '马丽', '赵丽颖', '高叶'],
    duration: '141分钟',
    region: '中国大陆',
    releaseDate: '2024-02-10',
    updateDate: '2026-07-10',
    tags: ['剧情', '法律', '现实主义', '社会'],
    isHot: false,
    isNew: false,
  },
  {
    id: 'm6',
    title: '解密',
    titleEn: 'Decoded',
    year: 2025,
    category: 'movie',
    rating: 7.5,
    description: '上世纪四十年代，世界局势风起云涌。数学天才容金珍被秘密带到一处隐蔽的基地，破解极其困难的密码。',
    longDescription: '上世纪四十年代，世界各国局势动荡不安。及时准确破译敌方的通讯密码至关重要。数学天才容金珍因为天赋异禀，被秘密机构发掘。他来到一处不为人知的神秘基地，开始了漫长而艰苦的密码破译工作。在这个过程中，他不仅面临着智力上的极限挑战，也逐渐发现了隐藏在密码背后的更大秘密。',
    director: '陈思诚',
    cast: ['刘昊然', '约翰·库萨克', '陈道明', '吴彦祖'],
    duration: '136分钟',
    region: '中国大陆',
    releaseDate: '2025-08-03',
    updateDate: '2026-07-22',
    tags: ['剧情', '悬疑', '历史', '谍战'],
    isHot: false,
    isNew: true,
  },
  {
    id: 'tv1',
    title: '狂飙',
    titleEn: 'The Knockout',
    year: 2023,
    category: 'tv',
    rating: 9.1,
    description: '一个跨越二十年的黑白较量故事。刑警安欣与黑恶势力高启强展开了一场长达二十年的正邪较量。',
    longDescription: '2000年，意气风发的刑警安欣与备受欺负的鱼贩高启强相识。随着高启强逐渐陷入涉黑犯罪的深渊，两人从朋友变成了对手。在随后的二十年里，安欣始终没有放弃对正义的追求，而高启强则在犯罪的道路上越走越远。这部剧生动描绘了中国扫黑除恶的艰辛历程和坚定决心，通过复杂的人物命运展现了一个时代的变迁。',
    director: '徐纪周',
    cast: ['张译', '张颂文', '李一桐', '张志坚'],
    duration: '39集',
    region: '中国大陆',
    releaseDate: '2023-01-14',
    updateDate: '2026-07-29',
    tags: ['剧情', '犯罪', '扫黑', '悬疑'],
    isHot: true,
    isNew: false,
  },
  {
    id: 'tv2',
    title: '庆余年第二季',
    titleEn: 'Joy of Life Season 2',
    year: 2024,
    category: 'tv',
    rating: 8.3,
    description: '范闲经历生死危机后重返京都，面对更加复杂的朝堂局势和权力斗争，他将继续在庆国书写自己的传奇。',
    longDescription: '经历了一场惊心动魄的生死考验后，范闲带着新的使命重返京都。此时的庆国朝堂暗流涌动，各方势力蠢蠢欲动。范闲不仅要面对来自朝堂的政治压力，还要继续寻找关于自己身世的真相。第二季在延续第一季轻松幽默风格的同时，剧情更加紧张刺激，人物关系更加错综复杂。',
    director: '孙皓',
    cast: ['张若昀', '李沁', '陈道明', '吴刚'],
    duration: '36集',
    region: '中国大陆',
    releaseDate: '2024-05-16',
    updateDate: '2026-07-20',
    tags: ['古装', '权谋', '喜剧', '玄幻'],
    isHot: true,
    isNew: false,
  },
  {
    id: 'tv3',
    title: '繁花',
    titleEn: 'Blossoms Shanghai',
    year: 2024,
    category: 'tv',
    rating: 8.7,
    description: '一九九二年的上海，煌煌大时代，人人争上游。阿宝在沪上弄潮，成为宝总，书写了一段传奇人生。',
    longDescription: '九十年代的上海，改革开放的春风让这座城市焕发出无穷的生机。主人公阿宝从一个普通青年逐步成长为商界传奇"宝总"。在这个过程中，他遇到了形形色色的人物，经历了商海沉浮和情感纠葛。王家卫导演以他独特的美学风格，将上海的繁华与市井、激情与克制展现得淋漓尽致。',
    director: '王家卫',
    cast: ['胡歌', '马伊琍', '唐嫣', '辛芷蕾'],
    duration: '30集',
    region: '中国大陆',
    releaseDate: '2024-01-09',
    updateDate: '2026-07-18',
    tags: ['剧情', '爱情', '年代', '商战'],
    isHot: false,
    isNew: false,
  },
  {
    id: 'tv4',
    title: '三体',
    titleEn: 'Three-Body',
    year: 2023,
    category: 'tv',
    rating: 8.0,
    description: '纳米科学家汪淼被警官史强带到联合作战中心，潜入一个神秘组织进行调查。一个关于外星文明的惊天秘密逐渐浮出水面。',
    longDescription: '2007年，地球基础科学出现了异常的扰动。纳米科学家汪淼被警官史强带到一个叫做"联合作战中心"的神秘机构。在这里，他发现了一个名为"科学边界"的神秘组织。随着调查的深入，汪淼接触到了一个名为"三体"的虚拟现实游戏，一个超出人类想象的宏大宇宙图景在他面前徐徐展开。',
    director: '杨磊',
    cast: ['张鲁一', '于和伟', '陈瑾', '王子文'],
    duration: '30集',
    region: '中国大陆',
    releaseDate: '2023-01-15',
    updateDate: '2026-07-12',
    tags: ['科幻', '悬疑', '剧情', 'IP改编'],
    isHot: false,
    isNew: false,
  },
  {
    id: 'v1',
    title: '奔跑吧第十二季',
    titleEn: 'Keep Running S12',
    year: 2026,
    category: 'variety',
    rating: 7.2,
    description: '全新一季继续欢乐开跑！常驻嘉宾和新加入的飞行嘉宾一起，在各种趣味十足的游戏中展开对决，带给你无限欢笑。',
    longDescription: '作为中国最具影响力的户外竞技真人秀节目之一，《奔跑吧》第十二季继续为观众带来欢乐。本季不仅保留了经典的撕名牌环节，还加入了更多创意十足的新游戏。新老成员之间的互动更加默契自然，每一期都让人捧腹大笑。',
    director: '姚译添',
    cast: ['李晨', '郑恺', '沙溢', '白鹿', '周深', '范丞丞'],
    duration: '12期',
    region: '中国大陆',
    releaseDate: '2026-04-25',
    updateDate: '2026-07-30',
    tags: ['综艺', '真人秀', '竞技', '搞笑'],
    isHot: true,
    isNew: true,
  },
  {
    id: 'a1',
    title: '斗破苍穹年番',
    titleEn: 'Battle Through the Heavens',
    year: 2026,
    category: 'anime',
    rating: 8.4,
    description: '天才少年萧炎在创造了家族空前的修炼纪录后，突然成了废人。种种打击接踵而至，他遇到了戒指中的药老，开始了全新的修炼之路。',
    longDescription: '萧炎曾是萧家历史上空前绝后的天才，创造了家族最年轻的斗者纪录。然而在十二岁那年，他却遭遇了人生最大的挫折——斗气尽失，从云端跌落谷底。就在他几乎绝望之时，一枚神秘的戒指中苏醒的灵魂——药老，为他开启了全新的人生篇章。',
    director: '赵丙乐',
    cast: ['杨天翔', '冯骏骅', '赵路', '夏侯落枫'],
    duration: '52集',
    region: '中国大陆',
    releaseDate: '2025-06-15',
    updateDate: '2026-07-31',
    tags: ['动漫', '玄幻', '热血', '冒险'],
    isHot: true,
    isNew: true,
  },
  {
    id: 'd1',
    title: '地球脉动第三季',
    titleEn: 'Planet Earth III',
    year: 2024,
    category: 'doc',
    rating: 9.7,
    description: 'BBC史诗级自然纪录片。从海洋深处到陆地之巅，用镜头记录地球上最壮丽的自然奇观和野生动物的生存故事。',
    longDescription: '距离《地球脉动》第一季播出已经过去了十七年。第三季继续由大卫·爱登堡担任解说，摄制组走遍全球六大洲的41个国家和地区。用最先进的拍摄技术，记录了从未被拍摄到的动物行为，展现了自然界令人叹为观止的多样性和地球上生命之间微妙而紧密的联系。',
    director: 'BBC Studios',
    cast: ['大卫·爱登堡'],
    duration: '8集',
    region: '英国',
    releaseDate: '2024-10-22',
    updateDate: '2026-07-08',
    tags: ['纪录片', '自然', '动物', 'BBC'],
    isHot: false,
    isNew: false,
  },
  {
    id: 'm7',
    title: '飞驰人生2',
    titleEn: 'Pegasus 2',
    year: 2024,
    category: 'movie',
    rating: 7.6,
    description: '驾校教练张驰召集老朋友，与天才车手厉小海和总是考不过科目二的菜鸟学员组成了一个苦中作乐、鸡飞狗跳的团队。',
    longDescription: '曾经叱咤风云的拉力赛车手张驰，如今沦落为驾校教练，过着靠脸吃饭勉强维生的生活。然而他心中对赛车的热爱从未熄灭。机缘巧合下，他重新召集了老朋友孙宇强和记星，与天才车手厉小海一起组建了一支全新的车队。他们笑料百出地备战最后一届巴音布鲁克拉力赛。',
    director: '韩寒',
    cast: ['沈腾', '范丞丞', '尹正', '张本煜'],
    duration: '129分钟',
    region: '中国大陆',
    releaseDate: '2024-02-10',
    updateDate: '2026-07-05',
    tags: ['喜剧', '运动', '赛车', '励志'],
    isHot: false,
    isNew: false,
  },
  {
    id: 'm8',
    title: '奥本海默',
    titleEn: 'Oppenheimer',
    year: 2023,
    category: 'movie',
    rating: 8.8,
    description: '聚焦美国"原子弹之父"罗伯特·奥本海默在开发第一颗原子弹的过程中所扮演的角色，以及他在战后的道德困境。',
    longDescription: '克里斯托弗·诺兰执导的史诗传记片，讲述了理论物理学家罗伯特·奥本海默的故事。这位被称为"原子弹之父"的天才科学家，在二战期间主导了曼哈顿计划，成功研制出人类历史上第一颗原子弹。然而当蘑菇云在沙漠中升腾而起的那一刻，奥本海默意识到自己释放了一股足以毁灭世界的力量，他的内心陷入了永远的煎熬。',
    director: '克里斯托弗·诺兰',
    cast: ['基里安·墨菲', '艾米莉·布朗特', '马特·达蒙', '小罗伯特·唐尼'],
    duration: '180分钟',
    region: '美国',
    releaseDate: '2023-08-30',
    updateDate: '2026-06-20',
    tags: ['传记', '历史', '剧情', '战争'],
    isHot: false,
    isNew: false,
  },
  {
    id: 'm9',
    title: '年会不能停！',
    titleEn: 'Johnny Keep Walking!',
    year: 2023,
    category: 'movie',
    rating: 8.3,
    description: '钳工胡建林阴差阳错被调入集团总部，在集团裁员风波中引发一连串啼笑皆非的故事。',
    longDescription: '老实巴交的钳工胡建林因为一次阴差阳错的人事调动，被从分厂调到了集团总部。在大城市和总部这个完全陌生的环境里，他闹出了不少笑话。而当公司爆发大规模裁员风波时，所有人都以为他有什么特殊背景，纷纷前来巴结。一场荒诞但又发人深省的职场喜剧就此展开。',
    director: '董润年',
    cast: ['大鹏', '白客', '庄达菲', '王迅'],
    duration: '117分钟',
    region: '中国大陆',
    releaseDate: '2023-12-29',
    updateDate: '2026-06-15',
    tags: ['喜剧', '职场', '剧情', '讽刺'],
    isHot: false,
    isNew: false,
  },
];

export const getMoviesByCategory = (category: string): Movie[] => {
  if (category === 'all') return movies;
  return movies.filter((m) => m.category === category);
};

export const getHotMovies = (): Movie[] => {
  return movies.filter((m) => m.isHot);
};

export const getNewMovies = (): Movie[] => {
  return movies.filter((m) => m.isNew);
};

export const getMovieById = (id: string): Movie | undefined => {
  return movies.find((m) => m.id === id);
};